import { Component, OnInit, Input, ViewChild, ElementRef, ChangeDetectorRef} from '@angular/core';
import { UserProfile } from '../../models/user-profile';
import { pipe } from 'rxjs';
import { take } from 'rxjs';
import { Table } from 'primeng/table'
import { PrimeColumn } from '../../../common/models/prime-column';
import { Profile } from '../../../profiles/models/profile';
import { UserProfilesService } from '../../services/user-profiles.service';


@Component({
  selector: 'mojo-user-profile-table',
  templateUrl: './user-profile-table.component.html'
})
export class UserProfileTableComponent implements OnInit {
  
  @Input()
  profiles: Profile[] = [];
  @Input()
  userProfiles: UserProfile[] = [];

  selectedProfile: Profile = undefined;

  @ViewChild('dt', { static: true }) dataTable: Table;

  @ViewChild('container', { static: true }) dataTableContainerElement: ElementRef;

  selectedUserProfiles: UserProfile[] = [];
  displayCodes: boolean = false;
  displayDialog: boolean = false;
 
  @Input()
  loading = false;

  constructor(private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly userProfilesService: UserProfilesService) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  getPrimeColumns(): PrimeColumn[] {
    const columns: PrimeColumn[] = [];
    columns.push(
      {
        field: 'UserId',
        header: 'User Id',
        width: 80
  } as PrimeColumn,
      {
        field: 'Name',
        header: 'Name'
      } as PrimeColumn,
      {
        field: this.displayCodes ? 'SecurityGroupCode' : 'SecurityGroupDescription',
        header: 'Security Group'
      } as PrimeColumn,
      {
        field: 'FormsAdmin',
        header: 'Forms Administrator'
      } as PrimeColumn,
      {
        field: this.displayCodes ? 'WorkGroupCode' : 'WorkGroupDescription',
        header: 'Workgroup'
      } as PrimeColumn,
      {
        field: this.displayCodes ? 'LinkedManagerCode' : 'LinkedManagerDescription',
        header: 'Linked Manager'
      } as PrimeColumn,
      {
        field: this.displayCodes ? 'OfficeCode' : 'OfficeDescription',
        header: 'Office'
      } as PrimeColumn,
      
      {
        field: this.displayCodes ? 'RegionCode' :'RegionDescription',
        header: 'Region'
      } as PrimeColumn,
      {
        field: this.displayCodes ? 'CountryCode' :'CountryDescription',
        header: 'Country'
      } as PrimeColumn,
      {
        field: 'Profile',
        header: 'Profile'
      } as PrimeColumn
    );
    return columns;

  }

  onFilter(event: any) {
    this.changeDetectorRef.detectChanges();
  }

  isRowSelected(rowData: UserProfile) {

    if (this.selectedUserProfiles.filter(x => {
        return x.SystemUserId === rowData.SystemUserId;
      }).length >
      0) {
      return true;
    }
    return false;
  }

  openDialog() {
    this.displayDialog = true;
  }

  cancel() {
    this.displayDialog = false;
    this.selectedProfile = undefined;
  }

  changeSelected() {
    this.userProfilesService.setUserProfiles(this.selectedUserProfiles, this.selectedProfile).pipe(take(1)).subscribe();
    this.displayDialog = false;
    this.selectedProfile = undefined;
    this.selectedUserProfiles = [];
  }

  toggleCodesDescriptions() {
    this.displayCodes = !this.displayCodes;
  }

  getColSize(column: PrimeColumn): string {
    return column.width ? column.width + 'px' : undefined;
  }

  getSelectedUserIdsAsCsv(): string {
    return this.selectedUserProfiles.map(x => x.UserId).join(', ');
  }
}
